<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";

export default {
  name: "MarksProducts",
  components: {LoadingPage},
  
  setup(){

    let loading = ref(false)

    let products = ref([])

    function marks_prod() {

      loading.value = true
      FreeWorld.Heisenberg({action:'marks'} , 'info' , true).then((res)=>{

        loading.value = false
        products.value = res.data

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , marks_prod)
      })

    }
    marks_prod()
    
    return{
      
      loading,
      products,
      
    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main ">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">نشان شده ها</p>
        <router-link :to="{name:'ProfilePage'}">
          <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body w-100 mt-3">

      <div v-if="products.length === 0 && !loading" style="height: 45vh" class="d-flex w-100 animate__animated animate__fadeIn">
        <div class="d-flex flex-column align-items-center justify-content-end">
          <img src="../assets/img/bookmark_6941686.png" class="mb-3 w-50" alt="">
          <p class="font-3 font-bold">شما تا کنون محصولی را نشان نکرده اید!</p>
        </div>
      </div>

      <div v-else class="">

      <router-link :to="{name:'DetailsProducts',params:{pid:item.id}}" v-for="item in products" :key="item.id"
                   class="animate__animated animate__fadeInRight text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
        <div class="w-60 ml-3 d-flex flex-column justify-content-around">
          <div class="overflow-hidden">
          <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
          </div>

          <div class="overflow-hidden">
          <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>
          </div>
          <div class="d-flex align-items-center">

            <p class="font-5 d-flex font-color font-bold mr-3">
              <span class="">{{ item.price_show.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>
          </div>

          <div class="div_hr my-2"></div>

          <div class="d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center">
              <img class="icon_shop ml-2" src="../assets/img/store_light.svg" alt="">
              <p class="font-5">{{ item.shops }} فروشگاه</p>
            </div>

            <div class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</div>
          </div>

        </div>

        <div class="img_prod rounded-3 animated-background">
          <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
        </div>
      </router-link>

      </div>

    </div>

  </div>
  
</template>


<style scoped>

@media (min-width: 900px) {
  .img_prod {
    width: 26% !important;
    height: 12rem !important;
  }
}

.img_prod {
  width: 40%;
  height: 11.3rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.icon_shop {
  width: 15px;
}

</style>